import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/guides',
    name: 'guides',
    component: () => import(/* webpackChunkName: "about" */ '../views/guidesView.vue')
  },
  {
    path: '/events',
    name: 'events',
    component: () => import(/* webpackChunkName: "about" */ '../views/eventsView.vue')
  },
  {
    path: '/weather',
    name: 'weather',
    component: () => import(/* webpackChunkName: "about" */ '../views/weatherView.vue')
  }




  // articles
  ,
  {
    path: '/articles/bucees-new-colorado-proposal',
    name: 'Bucees new Colorado proposal',
    component: () => import(/* webpackChunkName: "about" */ '../views/articles/bucees-new-colorado-proposal.vue')
  },
  {
    path: '/articles/dont-colorado-my-texas',
    name: 'dont-colorado-my-texas',
    component: () => import(/* webpackChunkName: "about" */ '../views/articles/dont-colorado-my-texas.vue')
  },
  {
    path: '/articles/subaru-campaign',
    name: 'subaru-campaign',
    component: () => import(/* webpackChunkName: "about" */ '../views/articles/subaru-campaign.vue')
  },
  {
    path: '/articles/turkey-psycology',
    name: 'turkey-psycology',
    component: () => import(/* webpackChunkName: "about" */ '../views/articles/turkey-psycology.vue')
  },
  {
    path: '/articles/prime-vans',
    name: 'prime-vans',
    component: () => import(/* webpackChunkName: "about" */ '../views/articles/prime-vans.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
